import React from 'react'
import { Icon, Input, InputLeftElement, InputGroup } from '@chakra-ui/react'

import { Icons } from '../../../../icons'

export const SelectedDate = React.forwardRef((props, ref) => {
  return (
    <InputGroup size='sm' cursor='pointer'>
      <InputLeftElement pointerEvents='none' height='100%'>
        <Icon as={Icons.Calendar2} boxSize='1.25rem' />
      </InputLeftElement>

      <Input ref={ref} cursor='inherit' variant='outline' {...props} />
    </InputGroup>
  )
})
